import SubstanceProvenanceDetailPanel from 'components/DetailPanels/SubstanceProvenanceDetailPanel';
import BaseTable from 'components/Tables/BaseTable';
import { actions as productActions } from 'ducks/products';
import { actions as productRMActions } from 'ducks/productRawMaterials';
import React, { useState } from 'react';
import { connect } from 'react-redux';
import {
  getImmutableStoreById, groupBy, mixtureSubstancesByMixture, mixtureSubstancesBySubstance
} from 'selectors/generic';
import theme from 'source/theme';
import { MIXTURE, POLIMER, SUBSTANCE } from 'utils/constants/coreConstants';
import tableIcons from 'utils/icons/materialTableIcons';
import columns from 'utils/tables/columns/product/productSummary';
import noIcon from 'utils/tables/noIcon';
import { currentUser } from 'selectors/currentUser';

const iconSelector = (inOutFinalRM, setInOutFinalRM) => {
  const addToCargo = [
    {
      icon: tableIcons.AddToCargo(),
      tooltip: 'Carga',
      onClick: () => setInOutFinalRM('in'),
      position: 'toolbar'
    },
    {
      icon: tableIcons.AddToCargo(),
      tooltip: 'Carga',
      onClick: () => setInOutFinalRM('in'),
      position: 'toolbarOnSelect'
    }
  ];

  const formulation = [
    {
      icon: tableIcons.Formulation(),
      tooltip: 'Reacção',
      onClick: () => setInOutFinalRM('out'),
      position: 'toolbar'
    },
    {
      icon: tableIcons.Formulation(),
      tooltip: 'Reacção',
      onClick: () => setInOutFinalRM('out'),
      position: 'toolbarOnSelect'
    }
  ];

  const product = [
    {
      icon: tableIcons.FinalProduct(),
      tooltip: 'Produto final',
      onClick: () => setInOutFinalRM('final'),
      position: 'toolbar'
    },
    {
      icon: tableIcons.FinalProduct(),
      tooltip: 'Produto final',
      onClick: () => setInOutFinalRM('final'),
      position: 'toolbarOnSelect'
    }
  ];

  switch (inOutFinalRM) {
    case 'in':
      return [...formulation, ...product];
    case 'out':
      return [...addToCargo, ...product];
    case 'final':
      return [...addToCargo, ...formulation];
    case 'distr':
      return [...product];
    default:
      return [...formulation, ...product];
  }
};

// `product.product_raw_materials`, keyed by product_id. The three passes below
// walk it whole, so the index is asked once per pass, not once per row.
const compositionByProduct = groupBy('productRawMaterials', 'product_id');

const Component = props => {
  let {
    composition, highlightSubstances, inOutFinalRM, mixturesOfSubstance, productId,
    productsById, rawMaterialsById, substancesOfMixture, user
  } = props;
  const {
    createProductRM, fetchProduct, handleCloseDrawer, setInOutFinalRM,
    setHighlightMP, setHighlightSubstances, updateProductRM
  } = props;
  const tableRef = React.useRef(null);

  const [loading, setLoading] = useState(false);


  const summaryRawMaterials = [];

  /**
   * Algorithm to filter:
   *  - Subtances from mixtures in CARGA
   *  - Substances in CARGA
   *  - Substances in MP FINAL
   */

  /**
   * First adding all substances related with mixtures, assuming that the substance
   * has not been modified in exclusions AND all substances that have code (CARGA)
   **/
  (composition[productId] || []).forEach(prm => {

    if (prm.added_to_charge) {

      if (rawMaterialsById[prm.raw_material_id].type === MIXTURE) {
        (substancesOfMixture[prm.raw_material_id] || []).forEach(interSubstance => {
          const substanceId = interSubstance.substance_id;
          summaryRawMaterials.push({
            ...rawMaterialsById[substanceId],
            raw_material_final: false,
            added_to_charge: true,
            excluded_from_final_product: false,
            product_raw_material_id: null, // No id yet: whether this link exists is not known here
            contributes_to_hazard: false,
            code: rawMaterialsById[prm.raw_material_id].code,
            mixture_name: rawMaterialsById[prm.raw_material_id].name,
            mixture_id: prm.raw_material_id,
            mixture_substance_id: interSubstance.id,
            // mixture_substance_id: prm.raw_material_id.id,
            // id_produto_mp_mistura_caminho: prm.id
          });
        });
      } else if (!prm.mixture_id) {
        summaryRawMaterials.push({
          ...rawMaterialsById[prm.raw_material_id],
          raw_material_final: prm.raw_material_final,
          added_to_charge: prm.added_to_charge,
          excluded_from_final_product: prm.excluded_from_final_product,
          product_raw_material_id: prm.id,
          contributes_to_hazard: prm.contributes_to_hazard,
          mixture_name: '',
          mixture_id: null,
          mixture_substance_id: null
        });
      }
    }
  });


  /**
   * Finding Substances that overlap with the default/lazy ones created above
   * and putting these ones on top
   **/
  (composition[productId] || []).forEach(prm => {
    // TODO removed prm.added_to_charge from IF because is unclear how values come tagged from the API
    //if (prm.mixture_id && prm.added_to_charge) {
    if (prm.mixture_id) {

      const index = summaryRawMaterials.findIndex(s =>
        s.id === prm.raw_material_id &&
        s.mixture_id === prm.mixture_id
      );
      if (index >= 0) {
        summaryRawMaterials[index] =
          {
            ...summaryRawMaterials[index],
            product_raw_material_id: prm.id,
            excluded_from_final_product: prm.excluded_from_final_product,
            contributes_to_hazard: prm.contributes_to_hazard
          };
      }
    }
  });
  /**
   * Finding Substances with raw_material_final True (FINAL)
   * The above is incorrect, raw_material_final doesn't seem to make sense
   */
  (composition[productId] || []).forEach(prm => {
    if (
      !prm.added_to_charge &&
      !prm.mixture_id &&
      (rawMaterialsById[prm.raw_material_id].type === SUBSTANCE ||
        rawMaterialsById[prm.raw_material_id].type === POLIMER)
    ) {
      summaryRawMaterials.push({
        ...rawMaterialsById[prm.raw_material_id],
        raw_material_final: prm.raw_material_final,
        added_to_charge: prm.added_to_charge,
        excluded_from_final_product: prm.excluded_from_final_product,
        product_raw_material_id: prm.id,
        contributes_to_hazard: prm.contributes_to_hazard,
        code: null,
        mixture_name: null
      });
    }
  });
  /**
   * Filter summaryRawMaterials to get summarySubstances unrepeated
   */
  const summarySubstances = [];
  summaryRawMaterials.forEach(rm => {
    if (summarySubstances.findIndex(substance => substance.id === rm.id) === -1) {
      summarySubstances.push(rm);
    }
  });

  return (
    <BaseTable
      ref={tableRef}
      titleBack={true}
      titleAction={handleCloseDrawer}
      title={`${productsById[productId].code} - ${productsById[productId].name}`}
      //title={`PRODUTO FINAL`}
      columns={columns(user)}
      data={summarySubstances}
      options={{
        rowStyle: rowData => ({
          backgroundColor: highlightSubstances.includes(rowData.id) ?
            theme.palette.primary.light : ''
        })
      }}
      onRowClick={() => null}
      onRowDoubleClick={rowData => {
        setHighlightSubstances([rowData.id]);
        setHighlightMP([
          rowData.id,
          ...(mixturesOfSubstance[rowData.id] || []).map(mixture => mixture.mixture_id)
        ]);
      }}
      isLoading={loading}
      actions={iconSelector(inOutFinalRM, setInOutFinalRM)}
      detailPanel={[
        // rowData => rowData.mixtures.length === 0 ?
        rowData => summaryRawMaterials
          .filter(obj => (obj.id === rowData.id) && (obj.mixture_id || obj.added_to_charge)).length > 0 ?
          {
            icon: tableIcons.Mixtures,
            tooltip: 'Proveniência',
            render: () => <SubstanceProvenanceDetailPanel rowData={rowData} data={summaryRawMaterials}/>
          } :
          noIcon
      ]}
      editable={{
        //isEditable: rowData => !rowData.excluded_from_final_product,
        onRowUpdate: newData => {
          setLoading(true);
          const promises = [];
          const repeatedSubstances = summaryRawMaterials.filter(rm => rm.id === newData.id);
          repeatedSubstances.forEach(rs => {
            if (rs.product_raw_material_id) {
              // TODO remove property id_produto_mp_mistura_caminho: rs.id_produto_mp_mistura_caminho
              // after Nuno fixs API
              promises.push(updateProductRM(
                rs.product_raw_material_id,
                {
                  contributes_to_hazard: newData.contributes_to_hazard,
                  excluded_from_final_product: newData.excluded_from_final_product,
                  //id_produto_mp_mistura_caminho: rs.id_produto_mp_mistura_caminho
                }
              ));
            } else {
              promises.push(createProductRM(
                {
                  product_id: productId,
                  raw_material_id: rs.id,
                  raw_material_final: rs.raw_material_final,
                  added_to_charge: rs.added_to_charge,
                  contributes_to_hazard: newData.contributes_to_hazard,
                  excluded_from_final_product: newData.excluded_from_final_product,
                  mixture_id: rs.mixture_id,
                  mixture_substance_id: rs.mixture_substance_id,
                  //id_produto_mp_mistura_caminho: rs.id_produto_mp_mistura_caminho
                }
              ));
            }
          });
          return Promise.all(promises)
            .then(() => fetchProduct(productId))
            .catch(e => alert(e))
            .finally(() => setLoading(false));
        }
      }}
    />
  );
};

const makeMapStateToProps = () => {
  const rawMaterialsById = getImmutableStoreById('rawMaterials');
  const mapStateToProps = (state, props) => ({
    composition: compositionByProduct(state),
    mixturesOfSubstance: mixtureSubstancesBySubstance(state),
    productsById: state.products.models,
    rawMaterialsById: rawMaterialsById(state),
    substancesOfMixture: mixtureSubstancesByMixture(state),
    user: currentUser(state)
  });
  return mapStateToProps;
};

const mapDispatchToProps = dispatch => ({
  fetchProduct: id => dispatch(productActions.fetchOne(id)),
  updateProductRM: (id, data) => dispatch(productRMActions.updatePromise(id, data)),
  createProductRM: (data) => dispatch(productRMActions.createPromise(data))
});

export default connect(makeMapStateToProps, mapDispatchToProps)(Component);
